/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import style from './existingItem.module.scss';
import Indicator from 'components/adminList/components/indicator/indicator';
import UserData from 'components/adminList/components/userData/userData';
import { ChangeRoleRequest, OnlyId, Role, User } from 'store/types';
import Select from '@mui/material/Select';
import { MenuItem } from '@mui/material';
import DeleteIcon from 'icons/delete';
import { getRoleName } from 'utils/utils';
import cx from 'classnames';

const rolesColors: { [x: string]: string } = {
  admin: '#6A4192',
  editor: '#009DAE',
  viewer: '#73C906',
};

export default function RequestItem({
  user,
  onChangeRole,
  onDeleteUser,
}: {
  user: User;
  onChangeRole: (arg: ChangeRoleRequest) => void;
  onDeleteUser: (arg: OnlyId) => void;
}) {
  const [role, setRole] = useState<Role>(user.role);

  useEffect(() => {
    setRole(user.role);
  }, [user.role]);

  return (
    <div className={'adminListItem'}>
      <Indicator bgColor={rolesColors[String(user.role)]}></Indicator>
      <UserData user={user}></UserData>
      <div className={'vertical'}></div>

      <Select
        className={cx(style.select, style[user.role], 'no-select')}
        variant="filled"
        value={role}
        onChange={(event) =>
          onChangeRole({
            _id: user._id,
            role: event.target.value as Role,
          })
        }
        MenuProps={{
          disableScrollLock: true,
        }}
        disableUnderline={true}
      >
        <MenuItem value={'admin'}>{getRoleName('admin')}</MenuItem>
        <MenuItem value={'editor'}>{getRoleName('editor')}</MenuItem>
        <MenuItem value={'viewer'}>{getRoleName('viewer')}</MenuItem>
      </Select>

      <div className={'vertical'}></div>
      <DeleteIcon
        className={style.delete}
        onClick={() => {
          onDeleteUser({
            _id: user._id,
          });
        }}
      ></DeleteIcon>
    </div>
  );
}
